/**
 * Adminator Admin Template
 * Modern Entry Point - Phase 2 Modernization
 */

// Import the modern application
import './app.js';

// Import all React components from single source
import '../../components/index.js';

// Legacy imports that haven't been modernized yet
// These will be gradually replaced in future iterations
import './datatable';
// import './datepicker'; // REMOVED: Replaced with modern day.js implementation in app.js

// Note: The following have been modernized and are now handled by app.js:
// - sidebar (now Sidebar component)
// - charts (now ChartComponent using Chart.js instead of jQuery Sparkline)
// - Basic DOM utilities (now DOM utils)

